// src/pages/dashboard/section-labita/SectionPlantation.jsx
import React from "react";
import { Paper, Stack, Typography, Box, Grid } from "@mui/material";
import GrassOutlinedIcon from '@mui/icons-material/GrassOutlined';

import AkumUreaBibitBesar from "../../plantation/setara-urea/AkumUreaBibitBesar";
import AkumUreaBibitSedang from "../../plantation/setara-urea/AkumUreaBibitSedang";
import AkumUreaBibitKecil from "../../plantation/setara-urea/AkumUreaBibitKecil";
import AkumUreaRatoon from "../../plantation/setara-urea/AkumUreaRatoon";

import GypsumPerMonth from "../../plantation/gypsum/GypsumPerMonth";

function SectionPlantation({ paperShadow }) {
    return (
        <Paper
            sx={{
                p: 3,
                mb: 3,
                borderRadius: 2,
                boxShadow: paperShadow,
            }}
        >
            <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
                <GrassOutlinedIcon sx={{ fontSize: 32, color: "#4CAF50" }} />
                <Box>
                    <Typography variant="h6" fontWeight="bold">
                        Plantation
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Deskripsi
                    </Typography>
                </Box>
            </Stack>
            <Typography variant="body1" color="text.primary">
                <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid size={6}>
                    <AkumUreaBibitBesar />
                  </Grid>
                  <Grid size={6}>
                    <AkumUreaBibitSedang/>
                  </Grid>
                  <Grid size={6}>
                    <AkumUreaBibitKecil/>
                  </Grid>
                  <Grid size={6}>
                    <AkumUreaRatoon/>
                  </Grid>

                  <Grid size={12}>
                        <GypsumPerMonth/>
                    </Grid>
                </Grid>

                
            </Typography>
        </Paper>
    );
}

export default SectionPlantation;